import React from "react";
import styled from "styled-components";
import { Icon } from "../Icon";
import { style } from "../style";
import kebabCase from "lodash/kebabCase";
import { ItemizedSummaryNoteItem } from "./types";
import { ItemizedSummaryNote } from "./ItemizedSummaryNote";

const OuterContainer = styled.div`
  all: unset;
  width: 100%;
  box-sizing: border-box;
  padding: ${style.vars.space[4]};
`;

const InnerContainer = styled.div`
  all: unset;
  width: 100%;
  box-sizing: border-box;

  display: flex;
  gap: 14px;
`;

const IconWrapper = styled.div`
  all: unset;
  flex-grow: 0;
  flex-shrink: 0;
`;

const TitleWrapper = styled.div`
  all: unset;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

const Title = styled.span`
  all: unset;

  display: flex;
  flex-direction: column;
  align-items: flex-start;

  color: ${style.colors.grey.darkest};
  font-weight: ${style.vars.fontWeight.bold};
`;

const Subtitle = styled.span`
  all: unset;
  color: ${style.colors.grey.dark};
  font-size: ${style.vars.fontSize.small};
`;

const TotalWrapper = styled.div`
  all: unset;

  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex-grow: 0;
  color: ${style.colors.grey.dark};
  text-align: right;
`;

const Spacer = styled.div`
  all: unset;
  display: block;
  width: 100%;
  height: ${style.vars.space[2]};
`;

type ItemizedRowProps = {
  title?: string;
  subtitle?: React.ReactNode;
  icon?: string;
  total?: string;
  notes?: ItemizedSummaryNoteItem[];
};

export const ItemizedRow: React.FC<ItemizedRowProps> = (props) => {
  const { title, icon, total, subtitle, notes = [] } = props;

  return (
    <OuterContainer>
      <InnerContainer>
        {icon && (
          <IconWrapper>
            <Icon large icon={icon} />
          </IconWrapper>
        )}
        <TitleWrapper>
          {title && <Title>{title}</Title>}
          {subtitle && <Subtitle>{subtitle}</Subtitle>}
        </TitleWrapper>
        {total && (
          <TotalWrapper data-testid={kebabCase(title)} data-price={kebabCase(title)}>
            {total}
          </TotalWrapper>
        )}
      </InnerContainer>
      {notes.map((note, index) => (
        <React.Fragment key={index}>
          <Spacer />
          <ItemizedSummaryNote item={note} />
        </React.Fragment>
      ))}
    </OuterContainer>
  );
};

ItemizedRow.displayName = "ItemizedRow";
